const config = {
  type: 'loversBurger',
  endDate: '2025/05/31',
  excludedDates: [
    '2025-05-29'
  ]
}

module.exports = config
